import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation, useNavigate } from 'react-router-dom';
import { findImage } from 'utils/Utils';
import { usePaymentState } from 'payment_state/PaymentStateContext';
import $ from 'jquery';
import LoadingIndicator from 'app/components/LoadingIndicator';
import LoadingText from 'app/components/LoadingText';

const MainScreen = () => {
  const navigate = useNavigate();
  const { setPaymentState } = usePaymentState();

  const searchParams = useLocation().search;

  const updatePaymentState = infoData => {
    setPaymentState(prevState => ({
      ...prevState,
      mid: infoData.mid,
      sign: infoData.sign,
      auth: infoData.auth,
      clientKey: infoData.clientKey,
      orderId: infoData.orderId,
      customerId: infoData.customerId,
      productName: infoData.productName,
      requestCurrency: infoData.requestCurrency,
      requestAmount: infoData.requestAmount,
      reqDate: infoData.reqDate,
      clientIp: infoData.clientIp,
      webhookUrl: infoData.webhookUrl,
      returnUrl: infoData.returnUrl,
      mallReserved: infoData.mallReserved,
      billkeyReq: infoData.billkeyReq,
      appScheme: infoData.appScheme,
      cancelUrl: infoData.cancelUrl,
    }));
  };

  const clearStorage = () => {
    window.sessionStorage.removeItem('auth');
    window.sessionStorage.removeItem('clientKey');
    window.sessionStorage.removeItem('mid');
    window.sessionStorage.removeItem('formSubmitted');
    window.sessionStorage.removeItem('returnType');
  };

  useEffect(() => {
    clearStorage();

    const params = new URLSearchParams(searchParams);
    const mid = params.get('mid');
    const auth = params.get('auth');
    const sign = params.get('sign');
    const clientKey = params.get('clientKey');
    const orderId = params.get('orderId');
    const customerId = params.get('customerId');
    const productName = params.get('productName');
    const requestAmount = params.get('requestAmount');
    const requestCurrency = params.get('requestCurrency');
    const reqDate = params.get('reqDate');
    const clientIp = params.get('clientIp');
    const webhookUrl = params.get('webhookUrl');
    const returnUrl = params.get('returnUrl');
    const mallReserved = params.get('mallReserved');
    const billkeyReq = params.get('billkeyReq');
    const appScheme = params.get('appScheme');
    const cancelUrl = params.get('cancelUrl');
    const returnType = params.get('returnType');

    updatePaymentState({
      mid,
      sign,
      auth,
      clientKey,
      orderId,
      customerId,
      productName,
      requestCurrency,
      requestAmount,
      reqDate,
      clientIp,
      webhookUrl,
      returnUrl,
      mallReserved,
      billkeyReq,
      appScheme,
      cancelUrl,
    });

    if (auth) {
      window.sessionStorage.setItem('auth', auth);
    }
    if (mid) {
      window.sessionStorage.setItem('mid', mid);
    }
    if (clientKey) {
      window.sessionStorage.setItem('clientKey', clientKey);
    }
    if (returnType) {
      window.sessionStorage.setItem('returnType', returnType);
    }
    navigate('/payment', { replace: true });
  }, []);

  return (
    <div className="payverse-wrap">
      <div className="payverse">
        <div
          style={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <LoadingIndicator style={{ height: '20%' }} />
          <LoadingText />
        </div>
      </div>
    </div>
  );
};

export default MainScreen;
